interface IClientContext {
    version: string;
}

export default (window as any).$$clientContext as IClientContext;